export const THIN = 100;
export const LIGHT = 300;
export const REGULAR = 400;
export const MEDIUM = 500;
export const BOLD = 700;
export const BLACK = 900;
